document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".photo-grid-social-counter").forEach((counter) => {
    if (!counter) return;
    const rawText = counter.textContent.trim();
    const finalValue = parseFloat(rawText);
    if (isNaN(finalValue)) return;                       // leave non-numeric text alone
    const decimals = (rawText.split(".")[1] || "").length;
    const duration = 2000, fps = 60;
    const totalFrames = (duration / 1000) * fps;
    const increment = finalValue / totalFrames;
    let currentValue = 0;
    const animation = setInterval(() => {
      currentValue += increment;
      if (currentValue >= finalValue) {
        clearInterval(animation);
        counter.textContent = rawText;                   // exact original, decimals intact
        return;
      }
      counter.textContent = currentValue.toFixed(decimals);
    }, 1000 / fps);
  });
});
